import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner.webp';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Bodor extends Component {
  render() {
    return (
      <div className='container-fluid'>

        <div className="supMain">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/SuB">SuB</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Bodor</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt=""/>
        </div>
        <div className="supMainText">
          <h1>Bodor Laser</h1>
            <Grid className="supMainInfo">
              <Row>
                <Col xsHidden smHidden md={3}>
                  <Carousel  controls={false} interval={3000}>
                    <Carousel.Item >
                        <img  src={InfoJumb1}  alt=""  height="100%" />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img  src={InfoJumb2} alt=""  height="100%"/>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img  src={InfoJumb3} alt=""  height="100%" />
                    </Carousel.Item>
                  </Carousel>
                  </Col>
                <Col xsHidden md={8}>
                  <h4>Bodor ist ein führender Hersteller von Laserschneidmaschinen, der sich durch innovative Technologien und hochwertige Produkte auszeichnet. Sie bieten eine breite Palette von Maschinen für verschiedene Anwendungen in der Metallverarbeitung an, darunter Faserlaserschneidmaschinen, Rohrlaserschneidmaschinen und Laserschweißmaschinen. Mit fortschrittlichen Technologien wie BodorThinker, BodorGenius und BodorPower gewährleisten sie höchste Leistung und Zuverlässigkeit. Bodor bietet zudem umfassenden Service und Support, einschließlich einer 5-Jahres-Garantie auf Kernkomponenten, und ist weltweit führend im Absatzvolumen von Laserschneidmaschinen.
                </h4>
                </Col>
                <Col xs={12}  smHidden mdHidden lgHidden>
                  <h4>Bodor ist ein führendes Unternehmen in der Herstellung von Laserschneidmaschinen, das sich durch seine innovativen Technologien und hochwertigen Produkte auszeichnet.
                </h4>
                </Col>
                <Col xs={12} md={{ span: 7, offset: 2 }}>
                  <Button className="supMainButtonWebPage" variant="light" href="https://www.bodor.com/" target="_blank">Hersteller Homepage</Button>
                </Col>
              </Row>
            </Grid>
            <br/>
        </div>



        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid>
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Innovative Technologien</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Durchgängiges Produktsortiment</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Hohe Präzision und Effizienz</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Direkter Support in Deutschland</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>5 Jahre Garantie auf Kernkomponenten</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Markführer im Bereich Laserschneiden</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Direkter Support in Deutschland</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Markführer im Bereich Laserschneiden</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Hohe Präzision und Effizienz</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; 5 Jahre Garantie auf Kernkomponenten</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>
          <Grid className="gridUp">
            <br/>
            <center>
            <h1>Produkte</h1>
            </center>
            <br/><br/>
            <Row className="show-grid">
              <Col  xs={12} sm={4}>
                <Link to="/Suppliers/Bodor/Laserschneiden">
                <center>
                  <div className="productsButton">
                    <h4 className="buttonBlue">Laserschneiden</h4>
                      <h5>Bodor bietet eine Auswahl an Laserschneidmaschinen, die speziell auf die Bedürfnisse der Metallverarbeitung zugeschnitten sind. Ihre Maschinen zeichnen sich durch hohe Präzision und Effizienz aus.</h5>
                      <p>Mehr ...</p>
                    
                  </div>
              </center>
              </Link>
              </Col>
              {/* <Col  xs={12} sm={4}>
                <center>
                  <div className="productsButton">
                    <h4 className="buttonBlue">Laserschweißen</h4>
                  <h5>Bodor bietet Laserschweißmaschinen an, die für präzises und effizientes Schweißen von Metallen entwickelt wurden.</h5>
                <p>Mehr ...</p>
              
              </div>
              </center>
              </Col> */}
              <Col  xs={12} sm={4}>
                <center>
                  <div className="productsButton">
                    <h4 className="buttonBlue">Automatisierung</h4>
                  <h5>Um die Effizienz weiter zu steigern, bietet Bodor verschiedene Automatisierungsgeräte an, die den Schneidprozess optimieren und die Produktivität erhöhen.</h5>
                <p>Mehr ...</p>
              
              </div>
              </center>
              </Col>
            </Row>
          </Grid>
            <br/>
        </section>
        </div>
    );
  }
}

export default Bodor;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/bodor/mainPageSup.js